/*=========================================================================================
  File Name: moduleActivityActions.js
  Description: Activity Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix Masa
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	addLayerItem({commit, dispatch}, layer) {
		return new Promise((resolve, reject) => {
			Api.post("/layer", layer)
				.then((response) => {
					const newLayer = {name};
					commit("CURRENT_LAYER_ITEM", Object.assign(newLayer, {id: response.data.id}));
					commit("ADD_LAYER_ITEM", Object.assign(newLayer, {id: response.data.id}));
					resolve(response.data.id);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchLayerListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/layer")
				.then((response) => {
					commit("SET_LAYERS", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchActivityById({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.get(`/layer/${itemId}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateLayerItem({commit}, {id, name, status_id}) {
		return new Promise((resolve, reject) => {
			Api.put(`/layer/${id}`, {name, status_id})
				.then((response) => {
					commit("UPDATE_LAYER", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeLayerItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/layer/${itemId}`)
				.then((response) => {
					commit("REMOVE_LAYER_ITEM", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeRelationshipLayerResource({commit}, payload = {zone_id: []}) {
		return new Promise((resolve, reject) => {
			Api.post(`/resource/zone/delete`, payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	addZoneItems({commit}, data) {
		commit("ADD_ZONE_ITEMS", data);
	},
	addChildrenItems({commit}, {rows}) {
		commit("ADD_ZONE_CHILDRES_ITEMS", {rows});
	},
	createAssigZoneResource({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/resourcezone", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateAssigZoneResource({commit}, {resource_id, zone_id}) {
		return new Promise((resolve, reject) => {
			Api.put(`/resourcezone/${resource_id}`, {zone_id})
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	deleteAssigZoneResource({commit}, relationId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/resourcezone/${relationId}`)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	assignedZoneResourceById({commit}, resourceId) {
		return new Promise((resolve, reject) => {
			Api.get(`/resourcezone/${resourceId}`)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
